import axios from 'axios';
import _this from './../main';
import router from './../router/index';
import qs from 'qs';


let baseURL;
if(process.env.NODE_ENV==='development'){
  // baseURL='https://admin-test.cdxishiduo.com/v1/';
  baseURL='http://xyf.local.com/v1/';
  // baseURL='https://admin-test.neweasygo.com/v1/';
}else{
  baseURL='/v1/';
}
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8';
let instance = axios.create({
  timeout: 50000,
  baseURL,
  withCredentials: false,
});

// 添加请求拦截器
instance.interceptors.request.use(
  function(config = {}) {
    if (config.method === 'post') {
      if(config.data instanceof FormData){
        return config;
      }else{
        config.data = qs.stringify({
          ...config.data,
          token: localStorage.getItem('token'),
        });
        return config;
      }
    }
    // if (localStorage.getItem('token')) {
    // config.headers.token = localStorage.getItem('token');
    // }
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    if (response.data.status === 0) {
      _this.$message.warning(response.data.msg);
      // //登录过期
      if (response.data.error_code === '403') {
        router.replace('/login');
      }
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  },
);
export default instance;
